"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDarkTheme = void 0;
const react_native_1 = require("react-native");
const storage_1 = __importDefault(require("../helper/storage"));
const useDarkTheme = () => {
    const colorScheme = react_native_1.Appearance.getColorScheme();
    const setDarkTheme = async (value) => {
        try {
            await storage_1.default.setItem("@color-mode", value);
        }
        catch (e) {
            console.log(e);
        }
    };
    const getDarkTheme = async () => {
        try {
            let val = await storage_1.default.getItem("@color-mode");
            if (val != null) {
                return val === "dark" || colorScheme === "dark" ? "dark" : "light";
            }
            else {
                return colorScheme === "dark" ? "dark" : "dark";
            }
        }
        catch (e) {
            return "light";
        }
    };
    return {
        setDarkTheme,
        getDarkTheme,
    };
};
exports.useDarkTheme = useDarkTheme;
